import React, { useState } from "react";
import contactBg from "../../assets/img/bg/7.png";
import contactBgVDO from "../../assets/img/bg/20.mp4";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sendContactQuery } from "../../Utils/SendMail";

function ContactUs() {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    contact: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleContactForm = (e) => {
    e.preventDefault();
    const { name, email, contact, message } = formValues;

    if (!name || !email || !contact || !message) {
      toast.error("All fields are required", {
        position: "top-center",
      });
    } else {
      sendContactQuery(name, email, contact, message)
        .then((responseMessage) => {
          toast.success(responseMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        })
        .catch((errorMessage) => {
          toast.error(errorMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className="breadcrumb-area bg-cover"
        // style={{ backgroundImage: `url(${contactBg})` }}
      >
        <video autoPlay muted loop className="video-background">
          <source src={contactBgVDO} type="video/mp4" />
        </video>
        <div className="container">
          <div className="breadcrumb-inner">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <h2 className="page-title">Contact</h2>
              </div>
              <div className="col-lg-6 text-lg-end">
                <ul className="page-list">
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <IoIosArrowForward />
                  <li>Contact</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="contact-page-inner bg-gray">
            <div className="section-title mb-4 pb-2">
              <h2 className="title">Ready to Elevate Your IT?</h2>

              <p className="content mb-0">
                At Tech Voyage Lab, we specialize in innovative IT solutions and
                expert consulting tailored to your business needs. Connect with
                us to discover how we can help you excel in the digital era.
              </p>
              <p className="content mb-0">
                Let's discuss your next IT project. Reach out today!
              </p>
            </div>
            <form onSubmit={handleContactForm}>
              <div className="row">
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <input
                      type="text"
                      placeholder="Your Name"
                      name="name"
                      value={formValues.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <input
                      type="text"
                      placeholder="Your Email"
                      name="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <input
                      type="text"
                      placeholder="Your Contact"
                      name="contact"
                      value={formValues.contact}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="single-input-inner">
                    <textarea
                      placeholder="Message"
                      name="message"
                      value={formValues.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-12 text-center">
                  <button
                    className="btn btn-base border-radius-5"
                    style={{ backgroundColor: "#3C6BFD" }}
                    type="submit"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
